import React from 'react';
import { BaseForm, Validators } from '../FormBuilder';
import { Row, Col } from 'reactstrap';
import { FieldEditor } from '../FormBuilder/FieldEditor';

export class DespatchNcrCreateForm extends BaseForm {
    constructor(props) {
        // Create an object that will represent the structure of the form.
        // This should include a definition for each field within the form (i.e. name, value, label etc.).
        // This will be passed to the constructor of the base class "BaseForm".
        const formDefinition = {
            fields: [
                {
                    name: "customerId",
                    label: "Customer",
                    editor: {
                        name: "dropdown",
                        options: props.customersOptions
                    }
                },
                {
                    name: "contacts",
                    label: "Contacts",
                    editor: {
                        name: "multicontactcheckbox",
                        options: props.contactsOptions
                    },
                    validators: [
                        Validators.required()
                    ]
                },
                {
                    name: "isEmailAlertsEnabled",
                    label: "Enable email alerts?",
                    editor: "checkbox",
                    value: true
                },
                {
                    name: "classificationTypeId",
                    label: "Classification Type",
                    editor: {
                        name: "dropdown",
                        options: props.classificationTypeOptions
                    },
                    validators: [
                        Validators.required()
                    ]
                },
                {
                    name: "stockCode",
                    label: "SKU"
                },
                {
                    name: "workTicketNo",
                    label: "Work Ticket / Batch No"
                },
                {
                    name: "quantity",
                    label: "Quantity",
                    editor: "number"
                },
                {
                    name: "operatorId",
                    label: "Operator Responsible",
                    editor: {
                        name: "dropdown",
                        options: props.operatorOptions
                    }
                },
                {
                    name: "description",
                    label: "Description of Issue",
                    validators: [
                        Validators.required()
                    ],
                    editor: "textarea"
                },
                // REMOVE IN V2!
                {
                    name: "dateCreated",
                    label: "Date Raised",
                    editor: {
                        name: "datepicker",
                        options: {
                            outputFormat: "YYYY-MM-DD"
                        }
                    },
                    validators: [
                        Validators.required(),
                        Validators.isDate()
                    ]
                }
            ]
        };                

        // Call the constructor of the base class.
        // As we are passing in the formDefintion and the form data (props.data),
        // This should setup the form accordingly.
        super(props, formDefinition, props.data);
    }

    handleCustomerChange(fields) {
        const customerId = fields.customerId.value * 1;            
        this.props.handleCustomerChange(customerId);    
        fields.contacts.editor.options = this.props.contactsOptions;  
    }

    getModel(fields) {
        // This function will override the logic to generate the model that is returned after submitting the form.
        // The generated model will be passed to the relevant handleSave() event, where it can be used to process the data accordingly.

        // Get the model that is generated by the BaseForm.
        // This gets the value for each field defined within the form and returns it as an object.
        // We can use this as the base model to work from and modify it accordingly before we return it.    
        const model = {
            ...this._getModel(fields),
            statusId: 1, // Set the Status to Open by Default
            classificationTypeId: fields.classificationTypeId.value * 1,
            customerId: fields.customerId.value * 1,
            operatorId: fields.operatorId.value * 1
        };

        return model;
    }

    // Override the renderFormFields() method to output an alternative form layout.
    // To do this, we will need to know what fields exist, so that we can provide the relevant field definition to the editor.
    // Doing this makes the form builder a bit less dynamic, but does give the flexibility to layout the form differently.  
    renderFormFields(fields, form) {  
        this.handleCustomerChange(fields);   
        return (
            <Row form>
                <Col xs="12" md="12">
                    <FieldEditor field={fields.customerId} actions={this.fieldActions} />
                    <FieldEditor field={fields.contacts} actions={this.fieldActions} />
                    <FieldEditor field={fields.isEmailAlertsEnabled} actions={this.fieldActions}/>
                    <FieldEditor field={fields.classificationTypeId} actions={this.fieldActions} />
                    <FieldEditor field={fields.stockCode} actions={this.fieldActions} />
                    <FieldEditor field={fields.workTicketNo} actions={this.fieldActions} />
                    <FieldEditor field={fields.quantity} actions={this.fieldActions} />
                    <FieldEditor field={fields.operatorId} actions={this.fieldActions} />
                    <FieldEditor field={fields.description} actions={this.fieldActions} />
                     {/* REMOVE IN V2!  */}
                     <FieldEditor field={fields.dateCreated} actions={this.fieldActions} />
                </Col>
            </Row>
        );
    }
}